// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fileAttachment-modal.ui.modal{max-width:570px !important;margin:0rem auto !important}.fileAttachment-modal.ui.modal>.content .file-attachment{max-height:calc(100vh - 170px)}", ""]);
// Exports
module.exports = exports;
